import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "../../Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: baseColors.white
    },
    searchBar: {
        backgroundColor: baseColors.green.light,
        color: baseColors.green.primary,

        elevation: 0
    }
})

export default styles
